module.exports = __webpack_public_path__ + "4c22d2f5d63ba4b75d219e8152419381.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/menu-toggler.png
 ** module id = 570
 ** module chunks = 0
 **/